import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



export default function DGTH_supplier_ddt({ entity, data, setData, searchObj, setSearchObj }) {

    const [filterActive, setFilterActive] = useState(null);

    function applyStatusFilter(statusValue) {
        setFilterActive(true);
        const constraints = [
            { fieldName: "status", type: "value", value: statusValue }
        ];
        setSearchObj({
            query: '',
            fields: [],
            constraints: constraints
        });
    }

    function removeFilter() {
        setFilterActive(false);
        setSearchObj({
            query: '',
            fields: [],
            constraints: []
        });
    }


    return (
        <>
            <Button className='m-2' variant='secondary' onClick={() => applyStatusFilter("0_PENDING")}>Provvisorio</Button>
            <Button className='m-2' variant='primary' onClick={() => applyStatusFilter("5_READY")}>Pronto</Button>
            <Button className='m-2' variant='success' onClick={() => applyStatusFilter("20_UNLOADED")}>Scaricato</Button>
            {filterActive ? (
                <Button className='m-2' variant='outline-danger' onClick={() => removeFilter()}>
                    <FontAwesomeIcon icon='trash' />
                </Button>
            ) : null}
        </>
    );
};
